module.exports = __webpack_public_path__ + "img/FRA.dac39f68.svg";